import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { loadPromotions } from '../services/promotions.service';

export function usePromotionsHook() {
    const dispatch = useDispatch();
    const idleCallbackId = useRef(null);
    const abortControllerRef = useRef(null);

    const promotionsList = useSelector(state => state.promotions.promotionsList);
    const { casinoId, countryCode, regulation, language, platformId } = useSelector(state => state.app);
    const { session, loyalty, personalSegments: { data: playerSegments } } = useSelector(state => state.player);

    const [isLoading, setIsLoading] = useState(!promotionsList);

    useEffect(() => {
        if (!casinoId && !countryCode && !regulation) {
            return;
        }

        let isSubscribed = true;
        abortControllerRef.current = new AbortController();

        const requestData = {
            casinoId,
            isLoggedIn: session && loyalty ? 1 : 0,
            country: countryCode,
            regulation,
            language: language.wpml,
            currencyCode: AsgFW.getCurrency(),
            platformId,
            ...(session && loyalty && { loyaltyLevel: loyalty.CurrentLevelNumber }),
        };

        if (session) {
            requestData.playerId = session?.EncryptedUserID;
        }

        loadPromotions({
            requestData,
            playerSegments,
            dispatch,
            isSubscribed,
            setIsLoading,
            abortSignal: abortControllerRef.current.signal,
            idleCallbackId,
        }).catch(e => {
            Tools.error('Error while getting promotions: ', e);
        }) ;

        return () => {
            isSubscribed = false;
            abortControllerRef.current?.abort();
            if (idleCallbackId.current) {
                if ('cancelIdleCallback' in window) {
                    window.cancelIdleCallback(idleCallbackId.current);
                } else {
                    clearTimeout(idleCallbackId.current);
                }
            }
        };
    }, [
        dispatch,
        casinoId,
        countryCode,
        regulation,
        language.wpml,
        platformId,
        session?.EncryptedUserID,
        loyalty?.CurrentLevelNumber,
        playerSegments,
    ]);

    return { promotionsList, isLoading };
}
